import type { PrintSummary } from "@/lib/api/client";

/** The window the Print page's summary (and its "has a print account" flag) covers. */
export const PRINT_SUMMARY_DAYS = 30;

/** The Print page's summary query key — the `print.start` guide block reads the same cache. */
export const printSummaryKey = (days: number) => ["print-summary", days] as const;

/** The bits of the print summary that decide how a cost is rendered. */
type CurrencyConfig = Pick<PrintSummary, "currency_symbol" | "currency_symbol_after">;

/**
 * Render a print cost using the site's currency settings.
 *
 * Falsy costs (0, null, undefined) render as "Free" — the backend nulls job
 * costs entirely when the site hides prices, so callers must also gate the
 * whole cost column/row on ``summary.show_prices``.
 */
export function formatCost(
  cost: number | null | undefined,
  currency?: CurrencyConfig | null,
): string {
  if (!cost) return "Free";
  const amount = cost.toFixed(2);
  const symbol = currency?.currency_symbol || "kr";
  const symbolAfter = currency?.currency_symbol_after ?? true;
  return symbolAfter ? `${amount} ${symbol}` : `${symbol}${amount}`;
}
